var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarDay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#444"
  }, /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    d: "M11 52h10a1 1 0 001-1v-8a1 1 0 00-1-1H11a1 1 0 00-1 1v8a1 1 0 001 1zM11 38h10a1 1 0 001-1v-8a1 1 0 00-1-1H11a1 1 0 00-1 1v8a1 1 0 001 1zM27 52h10a1 1 0 001-1v-8a1 1 0 00-1-1H27a1 1 0 00-1 1v8a1 1 0 001 1zM27 38h10a1 1 0 001-1v-8a1 1 0 00-1-1H27a1 1 0 00-1 1v8a1 1 0 001 1zM43 38h10a1 1 0 001-1v-8a1 1 0 00-1-1H43a1 1 0 00-1 1v8a1 1 0 001 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 10H8a6.006 6.006 0 00-6 6v37a6.006 6.006 0 006 6h48a6.006 6.006 0 006-6V16a6.006 6.006 0 00-6-6zm0 47H8a4 4 0 01-4-4V23h56v30a4 4 0 01-4 4z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    d: "M49 8V3a2 2 0 00-4 0v5zM19 8V3a2 2 0 00-4 0v5z"
  }))));
}

export default SvgCalendarDay;